<script setup lang="ts">
/**
 * RinganAjakanKilat — padanan <CaAjakanKilat>.
 *
 * Ini satu-satunya jembatan dari alat gratis ke produk berbayar, jadi ia WAJIB
 * ada di keempat halaman kompres. Kalimatnya dibawa apa adanya dari
 * CaAjakanKilat.vue; yang berubah hanya badge & tombolnya, yang kini memakai
 * versi ringan.
 *
 * <CaCard> dipakai LANGSUNG, bukan disalin: komponen itu murni utility CSS,
 * tidak menyentuh Nuxt UI sama sekali (sudah diperiksa), jadi tidak ada yang
 * perlu diringankan — dan memakainya kembali berarti tampilannya dijamin sama.
 */
withDefaults(defineProps<{ konteks?: string; ke?: string }>(), {
  konteks: '',
  ke: '/berkaskilat'
})
</script>

<template>
  <CaCard tone="emas" class="ca-pita-emas relative overflow-hidden">
    <div class="grid gap-5 lg:grid-cols-[1fr_auto] lg:items-center lg:gap-8">
      <div class="min-w-0">
        <RinganLencana tone="emas" icon="folder-check">BerkasKilat</RinganLencana>
        <p class="ca-h3 mt-3 text-ink text-balance">Berkasnya lebih dari satu?</p>
        <p class="mt-2.5 text-[0.9375rem] text-ink leading-relaxed">
          {{
            konteks ||
            'Pendaftaran biasanya menuntut enam sampai sembilan berkas dengan batas ukuran yang berbeda-beda — pas foto, swafoto, KTP, ijazah, transkrip.'
          }}
          Alat gratis ini memproses satu berkas per proses. BerkasKilat memproses semuanya sekali
          jalan memakai preset ukuran per instansi, lalu memberi laporan per berkas dan satu file ZIP siap unggah.
        </p>
      </div>
      <RinganTombol variant="emas" size="lg" :to="ke" class="shrink-0">
        Lihat BerkasKilat — Rp15.000
      </RinganTombol>
    </div>
  </CaCard>
</template>
